import { RefObject } from "react"
import { InputProps, Input as RACInput } from "react-aria-components"
import { RefCallBack } from "react-hook-form"

import { cn } from "@/utilities/etc"

interface Props extends InputProps {
  innerRef?: RefCallBack | RefObject<any>
  unstyled?: boolean
}

const BaseInput: React.FC<Props> = (props) => {
  const { innerRef, unstyled, ...rest } = props
  const classes = unstyled
    ? rest.className
    : cn(rest.className, "input--1", "input")
  return (
    <RACInput
      {...rest}
      ref={innerRef}
      className={classes}
      style={
        unstyled ? { all: "unset", minWidth: 0, boxSizing: "content-box" } : {}
      }
    />
  )
}

export default BaseInput
